import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datePerZoneTransform'
})
export class DatePerZonePipe implements PipeTransform {

  transform(value: any, dateFormat: string = 'medium'): any {
    if (!value) return null;

    const date = new Date(value);

    // Use app's language setting for formatting
    const storedLang = localStorage.getItem('currentLang');
    const locale = storedLang === 'ar' ? 'ar-SA' : 'en-US';

    return formatDate(date, dateFormat, locale);
  }
}
